// extracted by mini-css-extract-plugin
export default {"wrap":"RF-z","fullWidth":"SF-z","hideOnDesktop":"TF-z","content":"UF-z","hasOpenedNav":"VF-z","crumbsList":"WF-z","dropdownsWrap":"XF-z"};